export const environment = {
  production: true,
  version: '671ad2bdb0',
  site_version: 'SITE_VERSION'
};
